module.exports = __webpack_public_path__ + "img/placeholder.5f8c58ec.png";